<template>
  <div class="pos-container">
    <b-card
      v-for="item in filteredItems"
      :key="item.id"
      class="pos-item"
      @click="itemSelected(item)"
    >
      <div
        v-if="item.name.length >= 12"
        :title="item.name"
        class="card-img-overlay"
      >
        <div class="card-img-square">
          <picture-placeholder
            :text-in="item.name.toLowerCase()"
            :color="'#fff'"
            :backgroundColor="'#bbb'"
            :pictureUrl="item.image_md_uri || item.image_uri"
          />
        </div>

        <span class="card-title-local">{{ item.name }}</span>
        <span class="card-text">{{ item.default_rate }}</span>
      </div>

      <div v-else class="card-img-overlay">
        <div class="card-img-square">
          <picture-placeholder
            :text-in="item.name.toLowerCase()"
            :color="'#fff'"
            :backgroundColor="'#bbb'"
            :pictureUrl="item.image_md_uri || item.image_uri"
          />
        </div>

        <span class="card-title-local">{{ item.name }}</span>
        <span class="card-text">{{ item.default_rate }}</span>
      </div>

    </b-card>
  </div>
</template>

<script>
  import PicturePlaceholder from "@/components/widgets/PicturePlaceholder";

  import {
    generateImage
  } from "@/utils/image-generator";

  export default {
    name: "ItemDisplay",
    props: {
      items: {
        type: Array,
        required: true,
        default: () => []
      },
      selectItem: {
        type: Function,
        required: false,
        default: () => {}
      },
      filterIds: {
        type: Array,
        required: false,
        default: ""
      }
    },
    components: {
      PicturePlaceholder
    },
    computed: {
      filteredItems: function () {
        if (0 == this.filterIds.length) {
          return this.items;
        }
        let retVal = [];

        for (let i = 0; i < this.items.length; i++) {
          for (let j = 0; j < this.items[i].item_tag.length; j++) {
            if (this.filterIds.includes(this.items[i].item_tag[j].tag_id)) {
              retVal.push(this.items[i]);
              break; // This item is good
            }
          }
        }
        return retVal;
      }
    },
    methods: {
      itemSelected(item) {
        if (this.selectItem) {
          this.selectItem(item);
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .pos-container {
    .card.pos-item {
      height: 20vh;
      width: 15vh;
      cursor: pointer;
      margin: 5px;
      color: black;
      font-weight: bold;
      line-height: 15px;
      display: inline-block;
      overflow: hidden;

      &:hover {
        background: #eee;

        .card-text {
          color: white;
        }

        .card-title {
          color: white;
        }
      }


      .card-img {
        opacity: .3;
      }

      .card-body {
        padding: 0;
        background-color: white;
        text-align: right;

        .card-text {
          position: absolute;
          top: 5px;
          right: 5px;
          color: #fff;
          text-shadow: 0px 0px 8px #000;
        }

        .card-img-square {
          position: absolute;
          width: 15vh;
          height: 15vh;
          top: -1px;
          left: -1px;
          background: #bbb;
        }

        .card-img-overlay {
          padding: 0;
          padding-top: 10px;
        }

        .card-title-local {
          position: absolute;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 9.5vw;
          overflow: hidden;
          bottom: 3px;
          right: 5px;
          font-size: 10pt;
          color: #555;
        }

        &:hover {
          .card-img {
            opacity: 1;
          }
        }
      }
    }
  }
</style>